module.exports = __webpack_public_path__ + "static/media/prev-arrow.61da33b2.svg";